/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

export default class NewsletterList extends PureComponent {
  static defaultProps = {
    disableNewsletters: false,
  };

  /**
   * Set PropTypes for this component.
   * @type {object}
   */
  static propTypes = {
    newsletters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    handleCheck: PropTypes.func.isRequired,
    handleSubNewsletterOnChange: PropTypes.func.isRequired,
    disableNewsletters: PropTypes.bool,
  };

  /**
   * Does a list have sub newsletters.
   *
   * @param {Object} newsletter The newsletter.
   * @returns {boolean}
   */
  static hasSubNewsletters(newsletter) {
    return 0 < newsletter.sub_newsletters.length;
  }

  render() {
    const {
      newsletters,
      handleCheck,
      handleSubNewsletterOnChange,
      disableNewsletters,
    } = this.props;

    const listClasses = classNames({
      newsletters__list: true,
      'newsletters__list--disabled': disableNewsletters,
    });

    return (
      <ul className={listClasses}>
        {
          newsletters.map((newsletter) => (
            <li
              className="newsletters__list-item"
              key={newsletter.newsletter_id}
            >
              <div className="checkbox">
                <input
                  type="checkbox"
                  id={`newsletter-${newsletter.newsletter_id}`}
                  onChange={() =>
                    handleCheck(
                      NewsletterList.hasSubNewsletters(newsletter),
                      newsletter.newsletter_id
                    )}
                  checked={newsletter.isChecked}
                  value={newsletter.newsletter_id}
                  disabled={disableNewsletters}
                />
                <label
                  htmlFor={`newsletter-${newsletter.newsletter_id}`}
                >
                  {newsletter.name}
                </label>
              </div>
              <div className="newsletters__description">
                {parse(DOMPurify.sanitize(newsletter.description))}
              </div>
              <div
                key={`sub-${newsletter.newsletter_id}`}
                className="newsletters__sub-newsletters"
              >
                <ul className="newsletters__list newsletters__sub-list">
                  {
                    newsletter.sub_newsletters.map((sub) => (
                      <li className="newsletters__sub-list-item checkbox">
                        <input
                          type="checkbox"
                          id={`newsletter-${sub.sub_newsletter_id}`}
                          onChange={(event) =>
                            handleSubNewsletterOnChange(
                              event,
                              newsletter
                            )}
                          checked={sub.isChecked}
                          value={sub.sub_newsletter_id}
                        />
                        <label
                          key={sub.sub_newsletter_id}
                          htmlFor={
                            `newsletter-${sub.sub_newsletter_id}`
                          }
                        >
                          {sub.sub_name}
                        </label>
                      </li>
                    ))
                  }
                </ul>
              </div>
            </li>
          ))
        }
      </ul>
    );
  }
}
